import { handleHideModal } from 'components/global/_helpers/global.helpers';
import SimpleModal from 'components/global/SimpleModal';
import UniversalInput from 'components/global/UniversalInput';
import { handleSubmitFolderEdit } from 'components/views/FounderVault/_helpers/founderVault.events';
import { $view } from 'signals/global.signals';

const FounderFolderEditModal = () => (
  <SimpleModal
    show={$view.value?.activeModal === 'founder-folder-edit'}
    title="Edit Folder"
    onHide={handleHideModal}
    onPrimaryClick={handleSubmitFolderEdit}
    primaryButtonText="Save"
    secondaryButtonText="Cancel"
    onSecondaryClick={handleHideModal}
    isLoading={$view.value?.isModalLoading}
  >
    <UniversalInput label="Folder Name" name="name" type="text" />
  </SimpleModal>
);

export default FounderFolderEditModal;
